import React from "react";
import { RCCSwitch } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { IMatba001Form, IMatba004 } from "../interface";

export interface IRadioSwitchSwot{
	analysisData: IMatba001Form;
	index: number;
	item: IMatba004;
	register: (RegisterOptions?: any) => void;
	changeItem: (row:IMatba004, change: boolean) => void;
}

const RadioSwitchSwot: React.FC<IRadioSwitchSwot> = ({
	analysisData,
	item,
	index,
	register,
	changeItem
}) => {
	const { translate } = useTranslation();

	const onChangeSwitch = (switchSwot: any, name: string) => {

		if(switchSwot.target.checked){
			const newItem = {
				...item,
				maa004Forca: name === "maa004Forca" ? "S" : "N",
				maa004Fraqueza: name === "maa004Fraqueza" ? "S" : "N",
				maa004Oportunidade: name === "maa004Oportunidade" ? "S" : "N",
				maa004Ameaca: name === "maa004Ameaca" ? "S" : "N"
			} as IMatba004;

			changeItem(newItem, true);
		}else{
			const newItem = {
				...item,
				maa004Forca: name === "maa004Forca" ? "N" : "N",
				maa004Fraqueza: name === "maa004Fraqueza" ? "N" : "N",
				maa004Oportunidade: name === "maa004Oportunidade" ? "N" : "N",
				maa004Ameaca: name === "maa004Ameaca" ? "N" : "N"
			} as IMatba004;

			changeItem(newItem, true);
		}
	};

	return(
		<>
			{
				analysisData.maa001Forca === "S" &&
				<RCCSwitch
					name={`[${index}].maa004Forca`}
					label={translate("Força")} 
					register={register} 
					defaultChecked={item.maa004Forca === "S" || false}
					onChangeCapture={(x) => onChangeSwitch(x, "maa004Forca")}
				/>
			}
												
			{
				analysisData.maa001Fraqueza === "S" &&
				<RCCSwitch
					name={`[${index}].maa004Fraqueza`}
					label={translate("Fraqueza")} 
					register={register} 
					defaultChecked={item.maa004Fraqueza === "S" || false}
					onChangeCapture={(x) => onChangeSwitch(x, "maa004Fraqueza")}
				/>
			}

			{
				analysisData.maa001Oportunidade === "S" &&
				<RCCSwitch
					name={`[${index}].maa004Oportunidade`}
					label={translate("Oportunidade")} 
					register={register} 
					defaultChecked={item.maa004Oportunidade === "S" || false}
					onChangeCapture={(x) => onChangeSwitch(x, "maa004Oportunidade")}
				/>
			}
												
			{
				analysisData.maa001Ameaca === "S" &&
				<RCCSwitch
					name={`[${index}].maa004Ameaca`}
					label={translate("Ameaça")} 
					register={register} 
					defaultChecked={item.maa004Ameaca === "S" || false}
					onChangeCapture={(x) => onChangeSwitch(x, "maa004Ameaca")}
				/>
			}
		</>
	);
};

export default RadioSwitchSwot;
